import React from 'react';
import {
  CashbackPlate,
  LinkWithGAClickButton,
  SectionSubTitle,
  Typography,
} from 'common/components';
import { createElementKey, removeSpecialCharacters } from 'utils';
import {
  CategoryCardBg,
  seasonStartCategoryCardBabel,
  seasonStartCategoryCardItem,
  seasonStartCategoryCardItems,
  seasonStartCategoryCardItemTextWrapper,
  seasonStartCategoryTitle,
} from './season-start-category-styles';

export type SeasonStartCategoryStructure = {
  discountBableSrc: string;
  img: {
    className?: string;
    srcLd: string;
    srcD: string;
    srcT: string;
    src: string;
  };
  itemList: {
    cashback?: number;
    href: string;
    img: {
      alt: string;
      src: string;
    };
    title: string;
  }[];
  title: string;
};

type SeasonStartCategoryProps = {
  category: SeasonStartCategoryStructure;
  elementBlock: string;
};

export const SeasonStartCategory: React.FC<SeasonStartCategoryProps> = ({ category, elementBlock }) => (
  <CategoryCardBg {...category.img} >
    <div>
      <SectionSubTitle color="text-invert" className={seasonStartCategoryTitle} margin="m" >
        {category.title}
      </SectionSubTitle>
      <img alt="Плашка со скидкой" className={seasonStartCategoryCardBabel} src={category.discountBableSrc} />
    </div>
    <div className={seasonStartCategoryCardItems}>
      {category.itemList.map((item, itemIndex) => (
        <LinkWithGAClickButton
          className={seasonStartCategoryCardItem}
          elementBlock={elementBlock}
          elementName={removeSpecialCharacters(category.title)}
          elementText={item.title}
          href={item.href}
          key={createElementKey('season-start-category-item', itemIndex)}
          title={item.title}>
          <img alt={item.img.alt} src={item.img.src} width={48} height={48} />
          <div className={seasonStartCategoryCardItemTextWrapper}>
            <Typography adaptive={false} variant="s" size="subtitle">
              {item.title}
            </Typography>
            {item.cashback && <CashbackPlate cashback={item.cashback} size="s" />}
          </div>
        </LinkWithGAClickButton>
      ))}
    </div>
  </CategoryCardBg>
);
